import { I18NextReactProvider as RawI18NextReactProvider } from 'i18next-react';
import { ComponentProps, FC, PropsWithChildren } from 'react';

// i18next-react's types predate React 18's FunctionComponent, which no longer implies `children`.
export const I18NextReactProvider = RawI18NextReactProvider as unknown as FC<
  PropsWithChildren<ComponentProps<typeof RawI18NextReactProvider>>
>;
